export const header = {
  en: {
    about: 'About',
    clothes: 'Clothes',
    reviews: 'Reviews',
    delivery: 'Delivery',
    contacts: 'Contacts',
    basketTotal: 'Total',
  },
  ua: {
    about: 'Про нас',
    clothes: 'Одяг',
    reviews: 'Відгуки',
    delivery: 'Доставка',
    contacts: 'Контакти',
    basketTotal: 'Всього',
  },
};
